import React from 'react';
import { AsyncSelect } from 'shared/inputs';
import { getUsersLookup } from 'src/fetch/users';

const UsersControl = (props) => (
  <div className="control-wrapper">
    <AsyncSelect
      placeholder='Type to search...'
      dataItemKey='id'
      textField='displayName'
      getData={(search) => getUsersLookup({ displayName: search })}
      {...props}
    />
  </div>
);

export default UsersControl;
